import React from 'react';

import { Banner } from '@repo/common';

import { ReactComponent as IdeaIcon } from '@repo/common/assets/icons/20px/icon_20px_idea-outline.svg';

const EducationBanner = ({ $isMobile, isMobileFullPage }) => {
  return (
    <div className='min-w-[280px] tabletH:max-w-[348px] w-full flex flex-col items-start gap-2 pb-4 tabletH:pb-0'>
      {!isMobileFullPage && (
        <Banner
          type='info'
          size='s'
          label='No awards yet? That’s okay.
Club activities, team projects, completed courses, 
or certification preparation all count.'
          labelKr={
            '아직 수상 경력이 없으신가요? 괜찮아요.\n동아리 활동, 팀 프로젝트, 수료한 과정,\n자격증 준비도 모두 인정됩니다.'
          }
          hideButton
          hideClose={!$isMobile}
          icon={<IdeaIcon />}
        />
      )}
      {!$isMobile && (
        <Banner
          type='info'
          size='s'
          label='Tips for writing strong activity descriptions'
          labelKr='활동 설명을 잘 작성하는 팁'
          message='Focus on what you actually did and achieved, 
not just what you learned. Start with
the outcome or recognition to quickly show 
impact, then highlight the design decisions 
behind it. Keep it concise and show how the
experience translates into real, practical work 
skills.'
          messageKr={
            '실제로 무엇을 하고 어떤 결과를 냈는지에 집중해 주세요.\n배운 내용만 나열하기보다, 결과나 성과로 시작해\n영향을 빠르게 보여 주세요. 그런 다음 그 과정에서의\n디자인 결정과 경험이 실제 업무 역량으로 어떻게\n이어지는지 간결하게 설명해 주세요.'
          }
          hideButton
          hideClose={!isMobileFullPage}
          icon={<IdeaIcon />}
        />
      )}
    </div>
  );
};

export default EducationBanner;
